export default __webpack_public_path__ + "static/individualproduct-2787c725b80795a28537b65cdcbec6d6.png";